import CreateAxiosInstance from './axiosConfig';

const APIClient = CreateAxiosInstance(import.meta.env.VITE_API_BASE_URL);

// Memory calls are optional/background (fire-and-forget saves) or surface
// their own inline errors (MemoriesSection) — suppress the global error modal
// (see EvalService's `quiet` pattern). Callers' .catch still runs; the
// interceptor re-rejects.
const QUIET = { customErrorHandler: () => {} };

export function getMemories() {
  return APIClient.get(`/user/memory`, QUIET);
}

export function createMemory(content, source = 'manual') {
  return APIClient.post(`/user/memory`, { content, source }, QUIET);
}

export function updateMemory(memoryId, content) {
  return APIClient.patch(`/user/memory/${memoryId}`, { content }, QUIET);
}

export function deleteMemory(memoryId) {
  return APIClient.delete(`/user/memory/${memoryId}`, QUIET);
}
